import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "mt-8 text-2xl px-5 font-semibold text-white" }
const _hoisted_3 = {
  key: 0,
  class: "text-rose-600 text-xl"
}
const _hoisted_4 = { class: "mt-10 min-h-[80vh] overflow-auto" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mx-4" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "mx-4" }
const _hoisted_10 = { class: "ml-10" }
const _hoisted_11 = { class: "mx-4 mt-5" }

import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import api from "@/api/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const store = useStore()
const route = useRoute()

const isNotProduction = process.env.VUE_APP_ENV !== 'production'

const openSideBar = (name) => {
  store.commit("navigation/setOpenSideBarNames", name)
}

const showSidebarItem = (sideBar) => {
  return !!sideBar;
}

const logout = () => {
  // Vuex store 초기화
  store.commit("token/setToken", "")
  store.commit("token/setRefreshToken", "")
  store.commit("token/setIsSuperAdmin", false)
  store.commit("token/setRole", "")
  
  // localStorage 초기화
  localStorage.removeItem('ACCESS_TOKEN')
  localStorage.removeItem('REFRESH_TOKEN')
  localStorage.removeItem('IS_SUPER_ADMIN')
  localStorage.removeItem('ROLE')
  localStorage.removeItem('ADMIN_MENUS')
  localStorage.removeItem('KAKAO_MANAGEMENT_RESULT_FORMAT_SETTING')
}

// 네비게이션 클릭 핸들러 (새로고침 기능 추가)
const handleNavClick = (navItem) => {
  // 현재 페이지와 같은 페이지를 클릭한 경우
  if (route.name === navItem.routeName) {
    // 새로고침
    window.location.reload()
  } else {
    // 다른 페이지로 이동 (router-link의 기본 동작)
    // 이 경우는 router-link가 자동으로 처리
  }

  // 모바일에서 사이드바 닫기
  clickOpen()
}

const isOpen = computed(() => store.state.sideBar.isOpen)

const clickOpen = () => store.commit("sideBar/useSideBar")

const activeClass = ref(
  "bg-gray-600 bg-opacity-25 text-gray-100 border-gray-100"
);
const inactiveClass = ref(
  "border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100"
)

const filterMenusByRole = (menus) => {
  if (localStorage.getItem('ROLE') === 'ROLE_ADMIN') return menus
  return menus.filter((menu) => menu.routeName !== 'KakaoManagement')
}

const sideBars = ref(filterMenusByRole(JSON.parse(localStorage.getItem('ADMIN_MENUS') || '[]')))

const loadMyMenus = () => {
  if (!localStorage.getItem('ACCESS_TOKEN')) return
  api.staff.myMenus().then((response) => {
    sideBars.value = filterMenusByRole(response.data || [])
    localStorage.setItem('ADMIN_MENUS', JSON.stringify(sideBars.value))
  })
}

onMounted(() => {
  loadMyMenus()
  window.addEventListener('admin-menus-updated', loadMyMenus)
})

onBeforeUnmount(() => window.removeEventListener('admin-menus-updated', loadMyMenus))


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([isOpen.value ? 'block' : 'hidden', "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden"]),
      onClick: clickOpen
    }, null, 2),
    _createElementVNode("aside", {
      class: _normalizeClass([isOpen.value ? 'translate-x-0 ease-out' : '-translate-x-full ease-in', "fixed inset-y-0 left-0 z-30 w-64 overflow-y-auto transition duration-300 transform bg-gray-900 lg:translate-x-0 lg:static lg:inset-0"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "Admin", -1)),
        isNotProduction
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 개발 테스트 페이지 "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sideBars.value, (sideBar, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "px-4",
            key: index
          }, [
            (showSidebarItem(sideBar))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (sideBar.type === 'own')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: sideBar.path,
                        class: _normalizeClass([
                'flex items-center py-2 duration-200 border-l-4 text-decoration-none',
                _ctx.$route.name === sideBar.routeName ? activeClass.value : inactiveClass.value
              ]),
                        onClick: ($event: any) => (handleNavClick(sideBar))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(sideBar.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class", "onClick"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", {
                          onClick: ($event: any) => (openSideBar(sideBar.routeName)),
                          class: _normalizeClass([
                  'flex items-center py-2 duration-200 border-l-4 text-decoration-none border-gray-900 text-gray-500 hover:bg-gray-600 hover:bg-opacity-25 hover:text-gray-100',
                  // @ts-ignore
                  sideBar.childrenRouteNames.includes(_ctx.$route.name) ? activeClass.value : inactiveClass.value
                ])
                        }, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(sideBar.name), 1)
                        ], 10, _hoisted_8),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sideBar.children, (children, index) => {
                          return (_openBlock(), _createBlock(_component_router_link, {
                            key: index,
                            to: children.path,
                            class: _normalizeClass([
                  _unref(store).state.navigation.openSideBarNames.includes(sideBar.routeName) ? '' : 'hidden',
                  'flex items-center py-2 duration-200 border-l-4 text-decoration-none',
                  _ctx.$route.name === children.routeName ? activeClass.value : inactiveClass.value
                ]),
                            onClick: ($event: any) => (handleNavClick(children))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_10, _toDisplayString(children.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class", "onClick"]))
                        }), 128))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: "/login",
          class: _normalizeClass(["px-6 py-2 mt-2 duration-200 border-l-4 text-decoration-none", [inactiveClass.value]]),
          onClick: logout
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Log out ")
          ])),
          _: 1
        }, 8, ["class"])
      ])
    ], 2)
  ]))
}
}

})